import { formatNumber, isInTheMillions, isNullOrUndefined } from '@weft/utils';

export function shortenNumber(num: number | undefined): string {
  const numValue = num ?? 0;

  if (!isInTheMillions(numValue)) {
    return formatNumber(numValue);
  }

  const scaledDownNumber = numValue / 10 ** 6;
  const [integerPart, fractionalPart] = scaledDownNumber.toString().split('.');

  const fractionDisplay = isNullOrUndefined(fractionalPart) ? '' : `.${fractionalPart.slice(0, 2)}`;

  return `${integerPart}${fractionDisplay}M`;
}

export function formatNumberWithPrecision(num: number | undefined, precision: number): string {
  const numValue = num ?? 0;

  return numValue.toLocaleString('en-US', { minimumFractionDigits: precision, maximumFractionDigits: precision });
}

export function formatPercentage(ratio: number) {  
  return `${formatNumberWithPrecision(ratio, 2)}%`;
}

export function formatNumberAbbreviated(number: number): string {
  return Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(Number(number));
}